module.exports = __webpack_public_path__ + "twilio-integ-logo.png?ed5ef74c031ef4888ba5deb7fbe7f59c";